import { useQuery } from '@tanstack/react-query'

import { accessControlApi } from '../pages/AccessControl/api/access-control.client'

export const MY_ABILITY_QUERY_KEY = ['access-control', 'me-ability'] as const

// Always-fresh: staleTime 0 + refetch on mount/focus so a permission change is
// reflected as soon as the sidebar or a gated component re-renders (e.g. on the
// next navigation), without a 5-min lag or a manual refresh. Each refetch is a
// single small /me/ability request. The server AbilityGuard remains the real
// boundary — this cache is UX freshness only, never persisted to localStorage.
export function useMyAbilityQuery() {
  return useQuery({
    queryKey: MY_ABILITY_QUERY_KEY,
    queryFn: () => accessControlApi.getMyAbility(),
    staleTime: 0,
    retry: false,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  })
}
